import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

let echoInstance = null;
let pollingIntervals = new Map();

// Fallback polling-based message fetching
let messageCache = new Map(); // Store last message ID per order

export function setupMessagePolling(orderId, callback) {
  if (pollingIntervals.has(orderId)) {
    return; // Already polling for this order
  }

  const interval = setInterval(async () => {
    try {
      const token = localStorage.getItem('mg_token') || localStorage.getItem('token');
      if (!token) {
        clearInterval(interval);
        pollingIntervals.delete(orderId);
        messageCache.delete(orderId);
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/service-orders/${orderId}/messages`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
          },
          credentials: 'include'
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.data && data.data.messages && Array.isArray(data.data.messages)) {
          // Pass all messages (the component will manage state)
          callback(data.data.messages);

          // Update cache with last message ID
          if (data.data.messages.length > 0) {
            const lastMsg = data.data.messages[data.data.messages.length - 1];
            messageCache.set(orderId, lastMsg.id);
          }
        }
      }
    } catch (error) {
      console.error('Polling error:', error);
    }
  }, 3000); // Poll every 3 seconds

  pollingIntervals.set(orderId, interval);
}

export function stopMessagePolling(orderId) {
  const interval = pollingIntervals.get(orderId);
  if (interval) {
    clearInterval(interval);
    pollingIntervals.delete(orderId);
  }
}

export function initializeEcho() {
  if (echoInstance) {
    return echoInstance;
  }

  // Try to use Reverb, but gracefully fallback if unavailable
  const key = process.env.REACT_APP_REVERB_APP_KEY || 'p7sqjfdqd6ojqj8mgc32';

  try {
    echoInstance = new Echo({
      broadcaster: 'pusher',
      key: key,
      wsHost: window.location.hostname,
      wsPort: 8080,
      wssPort: 8080,
      forceTLS: false,
      enabledTransports: ['ws', 'wss'],
      disableStats: true,
    });
  } catch (error) {
    console.warn('Echo/Reverb initialization failed, using polling fallback:', error);
    return null;
  }

  return echoInstance;
}

export function getEcho() {
  if (!echoInstance) {
    return initializeEcho();
  }
  return echoInstance;
}

export function subscribeToServiceOrder(orderId, callbacks) {
  const echo = getEcho();

  return echo
    .private(`service-order.${orderId}`)
    .listen('MessageSent', (data) => {
      if (callbacks.onMessageSent) {
        callbacks.onMessageSent(data);
      }
    })
    .error((error) => {
      console.error('Echo subscription error:', error);
      if (callbacks.onError) {
        callbacks.onError(error);
      }
    });
}

export function unsubscribeFromServiceOrder(orderId) {
  const echo = getEcho();
  echo.leave(`service-order.${orderId}`);
}
